// Prefix used to track one Rokt identity request per email and browser session.
import { getRoktIdentityFromSession, setRoktGuestSessionData } from './roktUtils';

/**
 * Sends the hashed guest email to the Rokt SDK.
 * The request is best-effort, deduplicated per email/session, and never blocks booking.
 */
export const establishRoktIdentity = (hashedEmail: string): boolean => {
  try {
    if (!hashedEmail) {
      console.log('[Rokt] identity call skipped; no email provided');
      return false;
    }

    // Do not invoke identity twice for the same email in the same session.
    const roktData = getRoktIdentityFromSession();
    if (roktData?.invokedEmails?.includes(hashedEmail)) {
      console.log('[Rokt] identity call skipped; already invoked for this email/session');
      return false;
    }

    // SDK not available.
    if (!window?.mParticle?.Identity?.identify) {
      console.log('[Rokt] identity call skipped; SDK is unavailable');
      return false;
    }

    const identifyRequest = {
      userIdentities: {
        email_sha256: hashedEmail,
      },
    };

    window?.mParticle?.Identity?.identify(identifyRequest, () => {
      console.log('[Rokt] identity call succeeded');
    });

    setRoktGuestSessionData({
      ...roktData,
      invokedEmails: [...(roktData.invokedEmails || []), hashedEmail],
    });

    return true;
  } catch (error) {
    console.error('Rokt identity call failed', error);
    return false;
  }
};
